var r = { appliedFilters: {} }, s = (e) => ({ setFilters: ({ pageName: i, filters: t }) => e((l) => ({ medicineFilters: { appliedFilters: {
  ...l.medicineFilters.appliedFilters,
  [i]: t ?? []
} } })) });
export {
  s as createMedicineFiltersActions,
  r as initialMedicineFiltersState
};

//# sourceMappingURL=medicineFilters.action.js.map